import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { EvironmentAPI } from '../../../environments/enviroments.api'


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  heterLink = EvironmentAPI.heter_link;
  public form;

  constructor(
    public fb: FormBuilder,
    private sanitizer: DomSanitizer
  ) {
    this.form = fb.group({
      nome: ['', Validators.required],
      email: ['', Validators.required]
    });


  }

  ngOnInit() {
  }

  getURL (site: string) {
    const url =  EvironmentAPI[site]
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
